import React from "react";
import { withTranslation } from "react-i18next";
import get from "lodash/get";
import Modal from "../modal";
import Copy from "../inputs/copy";
import { RillContext } from "../../rill/RillReact/share/base";

class ShareModal extends React.Component {
  render() {
    const { locals } = this.context;
    const { query, origin } = locals;
    const { t } = this.props;
    const snapshot = get(query, "modal.snapshot", "");
    const date = get(query, "modal.date");
    const shareURL = `${origin}/share/${snapshot}`;

    const twitterMessage = `${encodeURIComponent(shareURL)}`;

    return (
      <Modal width="600px" className="Share-Modal">
        <div className="head">
          <h2 className="alt">{t("shareModal.title")}</h2>
        </div>

        <div className="body">
          {date && t("shareModal.shareMetricsFrom")}
          {date && <b>{date}</b>}

          <div className="links">
            <a
              target="_blank"
              href={`https://www.facebook.com/sharer/sharer.php?u=${shareURL}`}
            >
              <img src="/img/svg/icon_facebook.svg" alt="facebook" />
            </a>
            <a
              target="_blank"
              href={`http://twitter.com/intent/tweet?status=${twitterMessage}`}
            >
              <img src="/img/svg/icon_twitter.svg" alt="twitter" />
            </a>
            <a
              target="_blank"
              href={`https://www.reddit.com/submit?url=${shareURL}`}
            >
              <img src="/img/svg/icon_reddit.svg" alt="reddit" />
            </a>
          </div>
        </div>

        <div className="foot">
          <div className="url-wrapper">
            <div className="url">{shareURL}</div>
          </div>
          <Copy text={shareURL}>
            <div className="button">{t("shareModal.copyLink")}</div>
          </Copy>
          <a href={shareURL} target="_blank" className="preview">
            {t("shareModal.previewPage")}
          </a>
        </div>
      </Modal>
    );
  }
}

ShareModal.contextType = RillContext;

export default withTranslation("coaching-portal")(ShareModal);
